export default class CategoryRoutingEnum {
    static get SCROLL() {
        return 'SCROLL';
    }

    static get PAGES() {
        return 'PAGES';
    }

    static get options() {
        return {
            SCROLL: this.SCROLL,
            PAGES: this.PAGES
        };
    }
}
